import { createStyles, Theme } from '@material-ui/core';

const styles = ({ spacing }: Theme) => createStyles({
  tabsRoot: {
    marginBottom: spacing(6),
  },
});

export default styles;
